import type { CommissionAccess } from '@/lib/app/commission-access';
import { Button } from '@/components/ui/button';

export function TeamTree({ teams, selectedId, onSelect }: {
  teams: CommissionAccess['teams']; selectedId?: number; onSelect: (id: number) => void;
}) {
  const ids = new Set(teams.map(t => t.id));
  const render = (parent: number | null, visited: Set<number>) => teams
    .filter(t => (t.parent_team_id && ids.has(t.parent_team_id) ? t.parent_team_id : null) === parent && !visited.has(t.id))
    .map(t => {
      const next = new Set([...visited, t.id]);
      const children = teams.some(child => child.parent_team_id === t.id);
      const button = <Button variant={selectedId === t.id ? 'secondary' : 'ghost'} className="h-auto whitespace-normal text-left justify-start" onClick={() => onSelect(t.id)}>{t.name}</Button>;
      return <li key={t.id}>{children ? <details open><summary className="cursor-pointer">{button}</summary><ul className="ml-4 border-l pl-3 space-y-1">{render(t.id, next)}</ul></details> : button}</li>;
    });
  return <nav aria-label="Team hierarchy"><ul className="space-y-1">{render(null, new Set())}</ul></nav>;
}
